import InputGroup from "core/inputs/InputGroup";
import ScrollToTop from "core/buttons/scroll-buttons/ScrollToTop";
import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { ENTITY } from "constants/info-header";
import { useState, useEffect } from "react";

const MissionsWorkers = ({ formattedMissions, workers, clients, role, id }) => {
  const [filteredList, setFilteredList] = useState([]);
  const createHeader = (
    key,
    id,
    defaultMessage,
    icon,
    minWidth,
    role,
    specificTitle
  ) => {
    let value;
    if (specificTitle) {
      value = <FormattedMessage id={id} defaultMessage={specificTitle} />;
    } else if (role) {
      value =
        role === ENTITY.CLIENT ? (
          <FormattedMessage
            id="consultant_title"
            defaultMessage="Consultant/Sous-traitant"
          />
        ) : (
          <FormattedMessage id={id} defaultMessage={defaultMessage} />
        );
    } else {
      value = <FormattedMessage id={id} defaultMessage={defaultMessage} />;
    }

    return {
      label: {
        key,
        value,
      },
      icon,
      minWidth,
    };
  };

  const header = [
    createHeader(
      "assignment-title",
      "mission_title",
      "Intitulé de la mission",
      "user",
      "22.3%"
    ),
    createHeader("client", "client", "Client", "user", "22.3%", role),
    createHeader(
      `${role}_worker`,
      `${role}_worker`,
      "User",
      "user",
      "13.85%",
      role,
      "Manager"
    ),
    createHeader("start", "start", "Début", "calendar", "7.9%"),
    createHeader("end", "end", "Fin", "calendar", "7.9%"),
    createHeader("status", "status", "Statut", "loading", "14.6%"),
  ];

  useEffect(() => {
    setFilteredList(formattedMissions);
  }, [formattedMissions, workers, clients]);

  const search = (list, val) => {
    return list.filter(
      (elm) =>
        elm?.name_for_search?.toLowerCase().indexOf(val.toLowerCase()) !== -1
    );
  };

  return (
    <div className="section">
      <ScrollToTop />
      <div className="display-flex">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={<FormattedMessage id="missions" defaultMessage="Missions" />}
        />
        <div id="input-search" className="search-parent">
          <div className="search">
            <InputGroup
              icon="search"
              placeholder="Rechercher intitulé de la mission ou client"
              onChange={(e) =>
                setFilteredList(search(formattedMissions, e.target.value))
              }
              color="violet"
            />
          </div>
        </div>
      </div>
      <div>
        <Table id={id} header={header} content={filteredList} />
      </div>
    </div>
  );
};

export default MissionsWorkers;
